export const environment = {
  production: true,
  apiUrl: 'https://qrapitest.validfill.com/api/cust/',
  domain: 'qruitest.validfill.com',
};
